import { Card, Col, Table } from "react-bootstrap";
import React from "react";

import { useTranslation } from "react-i18next";

function ExtraSalesTable({ categoryId, data }) {
  const {
    t,
  } = useTranslation();

  const filterData = (data) => {
    return data.filter((row) => row.extraCategoryId === categoryId);
  };

  const totalQuantity = filterData(data).reduce((acc, row) => acc + parseInt(row.quantity), 0);
  const totalSum = filterData(data).reduce((acc, row) => acc + parseFloat(row.total), 0);
  const categoryExtra = data.find((el) => el.extraCategoryId === categoryId);

  return (
    <Card className="strpied-tabled-with-hover">
      <Card.Header>
        <Col>
          <Card.Title as="h4">{`[EXTRA] ${categoryExtra.extraCategoryName}`}</Card.Title>
        </Col>
      </Card.Header>
      <Card.Body className="table-responsive p-0">
        <Table className="table-hover" style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th>{t("tables.headers.name")}</th>
              <th className="align-text-right">{t("tables.headers.qty")}</th>
              <th className="align-text-right">{t("tables.headers.totalEuro")}</th>
            </tr>
          </thead>
          <tbody>
            {filterData(data).map((row) => (
              <tr key={row.id}>
                <td>{row.extraName}</td>
                <td className="align-text-right">{parseInt(row.quantity)}</td>
                <td className="align-text-right">{row.total.toFixed(2)}</td>
              </tr>
            ))}
            <tr key="total">
              <td>
                <strong>[EXTRA] {categoryExtra.extraCategoryName}</strong>
              </td>
              <td className="align-text-right">
                <strong>{totalQuantity}</strong>
              </td>
              <td className="align-text-right">
                <strong>{totalSum.toFixed(2)}</strong>
              </td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default ExtraSalesTable;
